(() => {
  function init(scope = document) {
    scope.querySelectorAll('.pp-footer-group').forEach(group => {
      if (group.dataset.layoutReady) return;
      group.dataset.layoutReady = 'true';
      const desktop = matchMedia('(min-width:750px)');
      const update = () => { group.open = desktop.matches; };
      update(); desktop.addEventListener('change', update);
    });
    const gallery = scope.querySelector('[data-product-gallery]');
    if (!gallery || gallery.dataset.layoutReady) return;
    gallery.dataset.layoutReady = 'true';
    const wrap = gallery.closest('.pp-product__gallery-wrap');
    const slides = [...gallery.querySelectorAll('[data-media-index]')];
    const prev = wrap.querySelector('[data-gallery-prev]'), next = wrap.querySelector('[data-gallery-next]');
    if (!prev || !next) return;
    let current = 0;
    function update() {
      const left = gallery.getBoundingClientRect().left;
      current = slides.reduce((best,slide,i) => Math.abs(slide.getBoundingClientRect().left-left)<Math.abs(slides[best].getBoundingClientRect().left-left)?i:best,0);
      wrap.querySelector('[data-gallery-count]').textContent = `${current+1} / ${slides.length}`;
      prev.disabled = current === 0; next.disabled = current === slides.length-1;
      wrap.querySelectorAll('[data-media-target]').forEach((button,i) => button.classList.toggle('is-active',i===current));
    }
    function go(delta) { const target = slides[Math.max(0,Math.min(slides.length-1,current+delta))]; gallery.scrollBy({left:target.getBoundingClientRect().left-gallery.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}); }
    prev.addEventListener('click',()=>go(-1)); next.addEventListener('click',()=>go(1));
    gallery.addEventListener('scroll',update,{passive:true}); new ResizeObserver(update).observe(gallery); update();
  }
  init(); document.addEventListener('shopify:section:load',event=>init(event.target));
})();

(() => {
 function initSubtitles(scope = document) {
  scope.querySelectorAll('[data-subtitle-wrap]').forEach(wrap => {
   if (wrap.dataset.ready) return;
   wrap.dataset.ready = 'true';
   const text = wrap.querySelector('[data-subtitle]');
   const button = wrap.querySelector('[data-subtitle-toggle]');
   const mobile = matchMedia('(max-width:749px)');
   let expanded = false;
   function measure() {
    wrap.classList.remove('is-collapsible','is-expanded');
    const needsToggle = mobile.matches && text.scrollHeight > parseFloat(getComputedStyle(text).lineHeight) * 2 + 2;
    button.hidden = !needsToggle;
    wrap.classList.toggle('is-collapsible', needsToggle);
    wrap.classList.toggle('is-expanded', expanded && needsToggle);
    button.setAttribute('aria-expanded', String(expanded && needsToggle));
    button.textContent = expanded ? 'Mostra meno' : 'Leggi di più';
   }
   button.addEventListener('click', () => { expanded = !expanded; measure(); });
   let width = 0;
   new ResizeObserver(entries => {const next = entries[0].contentRect.width; if (Math.abs(next-width) > .5) {width = next; measure();}}).observe(wrap);
   mobile.addEventListener('change', measure);
   document.fonts?.ready.then(measure);
   measure();
  });
 }
 initSubtitles(); document.addEventListener('shopify:section:load',event=>initSubtitles(event.target));
})();
